const AUTH_SESSION_TRANSITION_KEY = 'kindlumen:auth-session-transition'
const AUTH_SESSION_TRANSITION_WINDOW_MS = 15_000

function getTransitionTimestamp() {
  if (typeof window === 'undefined') {
    return null
  }

  let rawValue: string | null = null
  try {
    rawValue = window.sessionStorage.getItem(AUTH_SESSION_TRANSITION_KEY)
  } catch {
    // Storage can be blocked inside cross-site iframes; treat as no transition.
  }

  if (!rawValue) {
    return null
  }

  const timestamp = Number(rawValue)
  return Number.isFinite(timestamp) ? timestamp : null
}

export function markAuthSessionTransition() {
  if (typeof window === 'undefined') {
    return
  }

  try {
    window.sessionStorage.setItem(AUTH_SESSION_TRANSITION_KEY, `${Date.now()}`)
  } catch {
    // ignore — best effort
  }
}

export function clearAuthSessionTransition() {
  if (typeof window === 'undefined') {
    return
  }

  try {
    window.sessionStorage.removeItem(AUTH_SESSION_TRANSITION_KEY)
  } catch {
    // ignore — best effort
  }
}

export function isAuthSessionTransitionActive() {
  const timestamp = getTransitionTimestamp()

  if (!timestamp) {
    return false
  }

  return Date.now() - timestamp < AUTH_SESSION_TRANSITION_WINDOW_MS
}
